<template>
  <div class="bannerImg">

    <div class=" banner_main_left ">
      <el-carousel height="600px" class="swImg" arrow="never">
        <el-carousel-item v-for="(item, index) in imgList" :key="index" class="pointer">
          <img :src="item.img" @click="nav(item)" />
        </el-carousel-item>
      </el-carousel>
      <div class="zx">
        <div @click="goNext(`/xxxq?id=${item.id}&uName=新闻资讯`)" v-for="(item, index) in newsList" :key="index">
          <div class="tt elp">{{ item.title }}</div>
          <div class="dec elp">{{ item.introduction }}</div>
          <div class="t_btn">点击查看
            <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x27.png" alt="">
          </div>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import "@/assets/css/common.css";
import swipers from "@/components/swipers.vue";
import { getSurfaceList, } from "@/api/home";
import { getInfo } from "@/api/cookies";
import { getDomain } from "@/api/cookies";
import { queryAllArticle } from "@/api/home";

export default {
  components: { swipers },
  data() {
    return {
      imgList: [],
      domain: null,
      imgUrl: "",
      userSource: "PC端",
      userInfo: null,
      newsList: [      ]

    };
  },
  async created() {
    this.domain = getDomain();
    this.userInfo = await getInfo();
    getSurfaceList(1, undefined, this.domain.entrantsType).then((res) => {
      if (res.code == 0) {
        this.imgList = JSON.parse(JSON.stringify(res.msg));
      }
       queryAllArticle("", 5, 1).then((res) => {
        this.newsList = res.rows;
      });
    });
  },
  methods: {
    gogo() {
      Vue.prototype.goLoginView(true)
    },
    nav(item) {
      window.open(item.skipImg, "_blank");
    },
    oneMouseleave() {
      this.mainBoxShow = false;
    },

    toNext(url) {
      const routeUrl = this.$router.resolve({
        path: url,
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
<style lang="less" scoped>
.bannerImg {
  width: 100%;
  position: relative; 

  .bgimg {
    position: absolute;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;

      transition: opacity 0.5s;

      // &:hover {
      //   opacity: 0.5;
      //   /* 鼠标悬停时改变透明度 */
      // }
    }
  }
}


.banner_main {
  position: relative;
  display: flex;
  width: 1400px;
  margin: 0 auto;
  justify-content: space-between;
  // margin-top: 20px;

  .banner_main_left {
    width: 100%;
    height: 600px;
    position: relative;
    border-radius: 10px;
    overflow: hidden;

    .jg {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 80px;
      background: #ffffff;
      border-radius: 0px 0px 10px 10px;
      z-index: 999;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 52px;

      .jg_item {
        display: flex;
        align-items: center;
        cursor: pointer;

        .jg_item_left {
          width: 40px;

          img {
            width: 40px;
          }
        }

        .jg_item_right {
          margin-left: 8px;

          >div:nth-child(1) {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
          }

          >div:nth-child(2) {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            // margin-top: 5px;
          }
        }
      }
    }
  }
 
   
}

/* 轮播图 */
/deep/.swImg {
  width: 100%;
  height: 600px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;

  .el-carousel__item {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .el-carousel__arrow--left {
    left: calc(50% - 610px + 240px + 40px);
  }

  .el-carousel__arrow--right {
    right: 350px;
  }

  .el-carousel__arrow {
    width: 60px;
    height: 60px;
    background: rgba(0, 0, 0, 0.4);

    i {
      font-size: 30px;
      color: rgba(255, 255, 255, 0.8);
    }
  }

  img {
    /* max-width: 100%; */
    height: 600px;
    margin: auto;
  }
}



.el-input {
  width: 230px;
  height: 44px;
  background: #f8f8f8 !important;
  border-radius: 23px 23px 23px 23px;
}

::v-deep .el-input__inner {
  background: #f8f8f8 !important;
  border-radius: 23px 23px 23px 23px;
}

::v-deep .el-form-item__content {
  background: #f8f8f8 !important;
  border-radius: 23px 23px 23px 23px;
}

//隐藏滚动条
::-webkit-scrollbar {
  display: none !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none;
}
.zx{
  position: relative;
  z-index: 99;
  width: 1200px;
  margin:  0 auto;
  margin-top: -60px;
  display: flex;
  align-items: center;
  
  >div{
width: 224px;
height: 123px;
background: #FFFFFF;
box-shadow: 0px 0px 12px 1px rgba(204,204,204,0.3);
border-radius: 12px 12px 12px 12px;
border: 1px solid #EBF8FF;
margin-right: 20px;
background-image: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x28.png');
background-size: 100% 100%;
cursor: pointer;
padding: 16px;
&:last-child{
  margin-right: 0;
}
&:hover{
  border:none;
  background: #0067E8;
  background-image: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x29.png');
background-size: 100% 100%;
border: 1px solid #B5D0FF;
.tt{
  color: #fff;
}
.dec{
  color:#fff;
}
}
.tt{
   
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 15px;
color: #333333; 
}
.dec{ 
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 13px;
color: #9D95A2;
margin-top: 8px;
}
.t_btn{
  width: 99px;
height: 28px;
background: #E9F8FF;
border-radius: 14px 14px 14px 14px;
display: flex;
align-items: center;
justify-content: center; 
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 13px;
color: #0074EF;  
margin-top: 16px;
float: right;
img{
  width: 13px;
  margin-left: 6px;
}
}
  }
 
}
</style>
